module.exports = __webpack_public_path__ + "static/doppelganger-f656651d0defeee2e21ca37b10e82cb4.jpg";